var _path, _path2, _path3, _path4, _mask, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAllVacancies(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 5.83334H3.33332C2.41285 5.83334 1.66666 6.52624 1.66666 7.38096V15.1191C1.66666 15.9738 2.41285 16.6667 3.33332 16.6667H16.6667C17.5871 16.6667 18.3333 15.9738 18.3333 15.1191V7.38096C18.3333 6.52624 17.5871 5.83334 16.6667 5.83334Z",
    stroke: "#1976D2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66666 9.16669L8.33332 11.25",
    stroke: "#1976D2",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 9.16669L11.6666 11.25",
    stroke: "#1976D2",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 5.83334V3.61112C12.5 3.53745 12.3683 3.4668 12.1339 3.4147C11.8995 3.36261 11.5815 3.33334 11.25 3.33334H8.75C8.41848 3.33334 8.10054 3.36261 7.86612 3.4147C7.6317 3.4668 7.5 3.53745 7.5 3.61112V5.83334",
    stroke: "#1976D2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-1_2001_1592",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.91666,
    y: 10,
    width: 4.16667,
    height: 3.33333,
    rx: 1
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.91666,
    y: 10,
    width: 4.16667,
    height: 3.33333,
    rx: 1,
    stroke: "#1976D2",
    strokeWidth: 3,
    mask: "url(#path-5-inside-1_2001_1592)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllVacancies);
export default __webpack_public_path__ + "static/media/all_vacancies.ae99229254e98ec0747d52dbcf26a715.svg";
export { ForwardRef as ReactComponent };